//@flow

/**
 * A simple helper for making API error messages. Also distinguishes JS errors from API errors for clearer error logging
 * If a JS error were to happen in an async try-clause, this will throw it as is
 */
export default (error: {response?: {status: number}}, keyPrefix?: string): Array<string> | string => {

  if (error.response) {
    const errorStatus: number = error.response.status
    let errorKey = [`error.${errorStatus}`, 'error.500']

    if (keyPrefix) {
      errorKey.unshift(`${keyPrefix}.${errorStatus}`)
    }
    return errorKey
  }

  throw error
}



// WEBPACK FOOTER //
// ./src/util/createApiErrorMessage.js